import { isBefore, isValid } from "date-fns";

export const LAST_TERMS_UPDATE = new Date("01/01/2026");

export function areTermsAndConditionsUpToDate(
  terms_accepted_at: string | undefined,
): boolean {
  if (terms_accepted_at === null || terms_accepted_at === undefined)
    return false;

  return (
    isValid(new Date(terms_accepted_at)) &&
    isBefore(LAST_TERMS_UPDATE, new Date(terms_accepted_at))
  );
}
